import Api from './Api';

const END_POINT = 'bonos';

export default {

    async get_all(filters = null){
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request);
    },
    async store(bono) {
        return await Api.post(`${END_POINT}`, bono);
    },
    async update(bono) {
        return await Api.patch(`${END_POINT}/${bono.id}`, bono);
    },
    async change_status(bono) {
        return await Api.patch(`${END_POINT}/${bono.id}/change-status`, bono);
    },
    async delete(bono) {
        return await Api.delete(`${END_POINT}/${bono.id}`, bono);
    },
    async listarActivos() {
        return await Api.get('listarBonosActivos');
    }
}